__turbopack_context__.v({
  "root": "PlasmicTableThead-module__2gM-gG__root",
  "tableTh___1C0Ga": "PlasmicTableThead-module__2gM-gG__tableTh___1C0Ga",
  "tableTh__cg9Dj": "PlasmicTableThead-module__2gM-gG__tableTh__cg9Dj",
  "tableTh__f7Joj": "PlasmicTableThead-module__2gM-gG__tableTh__f7Joj",
  "tableTh__v3Lz": "PlasmicTableThead-module__2gM-gG__tableTh__v3Lz",
  "tableTr__ni9TZ": "PlasmicTableThead-module__2gM-gG__tableTr__ni9TZ",
});
